<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">LISTE DES POSTES PRÈS À L'ENVOI</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
        <text-input v-model="shippingNo" :error="errors.shippingNo" class="px-3 pb-8 w-full lg:w-1/3" label="N° envoi"/>
        <select-input v-model="selectedAgent" :error="errors.selectedAgent" class="pr-6 w-60" label="Envoyé par">
          <option disabled></option>
          <option v-for="agent in agents" :key="agent.id" :value="agent.id" >{{agent.name}}</option>
        </select-input>
        <button class="btn-indigo py-2.5 mr-4 flex h-11 mt-7 items-center disabled:opacity-50" @click="sendSelection" :disabled="selected.length === 0  || selectedAgent == null">
          <div v-if="sending" class="btn-spinner mr-2" />
          <span>Envoyer</span>&nbsp;
          <span class="hidden md:inline">la selection</span>
        </button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-2 pt-6 pb-4">N° Order</th>
          <th class="px-2 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Agence</th>
          <th class="px-6 pt-6 pb-4">Agent</th>
          <th class="px-6 pt-6 pb-4">Status</th>
          <th class="px-6 pt-6 pb-4">Imprimer</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="px-6 py-4 flex items-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="repair.id" v-model="selected">
            </div>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.brand }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.model}}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.agency }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center"
                          tabindex="-1">
              {{ repair.agent }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.payment }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer le Bordereaux D'expedition" @click="printBl([repair.id])">
              <svg class="h-10 w-10 mx-auto text-green-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import SelectInput from '@/Shared/SelectInput';
import TextInput from "../../Shared/TextInput";

export default {
  metaInfo: {title: 'POSTES PRÈS À L\'ENVOI'},
  layout: Layout,
  components: {
    TextInput,
    Icon,
    SearchFilter,
    Pagination,
    SelectInput,
  },
  props: {
    repairs: Object,
    filters: Object,
    errors: Object,
    agents: Array,
  },
  data() {
    return {
      selectedAgent: null,
      shippingNo: null,
      selected: [],
      selectAll: false,
      sending: false,
      form: {},
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('shipment.list', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    select() {
      this.selected = [];
      if (this.selectAll) {
        for (let i in this.repairs.data) {
          if (this.repairs.data.hasOwnProperty(i)) {
            this.selected.push(this.repairs.data[i].id);
          }
        }
      }
    },
    sendSelection() {
      const data = new FormData()
      data.append('ids', this.selected || [])
      data.append('agent', this.selectedAgent || '')
      data.append('shippingNo', this.shippingNo || '')
      this.$inertia.post(this.route('shipment.ship'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.printBl(this.selected)
          this.sending = false
          this.selected = []
        }
      })
    },
    printBl(ids) {
      window.open(this.route('shipment.generateBl', ids.join()), "_blank");
    },
  },
}
</script>
